import * as React from 'react';
import { useLocation, useNavigate } from 'react-router';
import { Button } from '@/components/ui/button';
import LanguagePopover from '@/layouts/LanguagePopover';
import { ThemeToggle } from '@/theme/ThemeToggle';
import { useLocales } from '@/locales';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';

import phoneIcon from '/assets/icons/flags/navbar-phone-icon.png';
import arrowIcon from '/assets/icons/flags/navbar-resurs-arrow-icon.png';
import user from '@/layouts/user.svg';
import { links } from '@/data';

import BurgerMenu from '@/components/ui/navigation/BurgerMenu';

export default function Header({
  scrollToElement,
  elementRefs,
  navPanel = true,
  active = '',
  handleActive = () => {},
}) {
  const { translate } = useLocales();
  const navigate = useNavigate();
  const location = useLocation();

  const [resourceMenuOpen, setResourceMenuOpen] = React.useState(false);

  const handleNavigation = path => {
    const canScrollToElement =
      path && path.current && typeof scrollToElement === 'function';

    if (location.pathname !== '/') {
      navigate('/');

      if (canScrollToElement) {
        setTimeout(() => {
          scrollToElement(path);
        }, 0);
      }

      return;
    }

    if (canScrollToElement) {
      scrollToElement(path);
    }
  };
  const pathname = location.pathname;
  const landingPages = ['/', '/calculation', '/directories'];
  const isLandingPage = landingPages.includes(pathname);

  const [click, setClicked] = React.useState(null);
  const handleBurgerToggle = React.useCallback(clicked => {
    setClicked(clicked);
  }, []);

  const scrollSections = [
    {
      key: 'about_us',
      label: translate('About_us'),
      ref: elementRefs?.aboutUsRef,
    },
    {
      key: 'partners',
      label: translate('Partners'),
      ref: elementRefs?.partnersRef,
    },
    {
      key: 'contacts',
      label: translate('Contacts'),
      ref: elementRefs?.contactsRef,
    },
    {
      key: 'faq',
      label: translate('FAQ'),
      ref: elementRefs?.faqRef,
    },
    {
      key: 'news',
      label: translate('News'),
      ref: elementRefs?.newsRef,
    },
  ];

  const routeNavItems = [
    {
      key: 'calc',
      label: translate('Calculator'),
      isActive: pathname.includes('calculation'),
      onClick: () => {
        navigate('/calculation');
        handleActive('calc');
      },
    },
    {
      key: 'directories',
      label: translate('directories'),
      isActive: pathname.includes('directories'),
      onClick: () => navigate('/directories'),
    },
  ];

  const handleScrollNavClick = section => {
    handleActive(section.key);
    handleNavigation(section.ref);
  };
  return (
    <header className="header-nav" id="header-nav-uniqe">
      <div className="header-nav__appbar">
        <div className="header-nav__appbar--right">
          <div className="appbar__logo" onClick={() => navigate('/')} />
          <h3 className="appbar__title">
            {translate('avto')}
            <span className="appbar__title--name">{translate('avto_two')}</span>
          </h3>
        </div>

        <div className="header-nav__appbar--left ">
          <ThemeToggle />
          <LanguagePopover />
          {/* original */}
          <div className="appbar__auth appbar__auth1">
            <Button onClick={() => navigate('/auth/user')}>
              {translate('login_register')}
            </Button>
          </div>
          {/* original */}
          <div className="appbar__auth appbar__auth2">
            <Button onClick={() => navigate('/auth/user')}>
              <img src={user} alt="user" />
              {active}
            </Button>
          </div>
          {isLandingPage ? <BurgerMenu myClicked={handleBurgerToggle} /> : null}
        </div>
      </div>

      {navPanel && (
        <nav
          className="header-nav__navbar"
          style={{ display: click ? 'none' : undefined }}
        >
          <ul className="header-nav__navbar--navlink">
            {scrollSections.map(section => (
              <li
                key={section.key}
                className={`navlink--item ${
                  active === section.key ? 'active' : ''
                }`}
                onClick={() => handleScrollNavClick(section)}
              >
                {section.label}
              </li>
            ))}
            <DropdownMenu
              open={resourceMenuOpen}
              onOpenChange={setResourceMenuOpen}
            >
              <DropdownMenuTrigger asChild>
                <li
                  style={{ display: 'flex', gap: '5px', alignItems: 'center' }}
                  className="navlink--item navlink-resurs"
                >
                  {translate('Resource')}
                  <img src={arrowIcon} alt="" style={{ marginTop: '2.5px' }} />
                </li>
              </DropdownMenuTrigger>
              <DropdownMenuContent>
                {links.map((link, index) => (
                  <DropdownMenuItem key={link.url ?? index}>
                    <a
                      href={link.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ textDecoration: 'none', color: '#1a5c7d' }}
                    >
                      {translate(`country_${index + 1}`)}
                    </a>
                  </DropdownMenuItem>
                ))}
              </DropdownMenuContent>
            </DropdownMenu>
            {routeNavItems.map(item => (
              <li
                key={item.key}
                className={`navlink--item ${item.isActive ? 'active' : ''}`}
                onClick={item.onClick}
              >
                {item.label}
              </li>
            ))}
          </ul>

          <div className="header-nav__contacts">
            <Button
              variant="ghost"
              size="icon"
              className="header-nav__contacts--icon"
            >
              <img src={phoneIcon} alt="phone icon" />
            </Button>
            <div className="header-nav__contacts--details">
              <h5>{translate('Have_you_question')}</h5>
              <h4>
                <a href="tel:+99-855-506-45-54">+998 (55) 506 45 54</a>
              </h4>
            </div>
          </div>
        </nav>
      )}
    </header>
  );
}
